/*
export function someMutation (state) {
}
*/

export function SET_DOCUMENT(state, obj) {
  state.documento = obj;
}
